import { render, staticRenderFns } from "./RegisterSchwedt.vue?vue&type=template&id=053294a1&scoped=true"
import script from "./RegisterSchwedt.vue?vue&type=script&lang=js"
export * from "./RegisterSchwedt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053294a1",
  null
  
)

export default component.exports